/* @flow */

import * as React from 'react';

import classnames from 'classnames';

import {Card} from '../card/card';
import {colors} from '../colors';
import {AiSparkleNewIcon} from '../icon/svg/ai-sparkle-new-icon';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import './ai-badge.module.css';

type Props = {|
    size?: 'normal' | 'large',
|};

export function AiBadge(props: Props) {
    const {size = 'normal'} = props;

    const styleName = classnames('ai-summary-badge', {
        'ai-summary-badge--large': size === 'large',
    });

    return (
        <Card hasBorder={true} borderRadius={4} variant='ai' fitContent={true}>
            <div styleName={styleName}>
                <Stack isHorizontal={true} spacing={4} alignItems='center'>
                    {size === 'large' ? (
                        <AiSparkleNewIcon
                            size={14}
                            color={colors.aiPurplePrimary}
                            alignCenter={true}
                            wrapWithDiv={false}
                        />
                    ) : null}
                    <Body size={size === 'normal' ? 'tiny' : 'small'} isBold={true}>
                        Nutshell AI
                    </Body>
                </Stack>
            </div>
        </Card>
    );
}
